import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
const root = createRoot(document.getElementById('root')!);
root.render(<React.StrictMode data-id="element-362" data-mp="1wcxstkych0dq">
    <App data-id="element-363" data-mp="21ah6ain7x94m" />
  </React.StrictMode>);